

import { useEffect, useState } from 'react';
import * as Yup from 'yup'
import { SpinContainer } from '../../../StyledComponents/Queries';
import { DetailContainer, FormikForm, FormItem } from '../../../StyledComponents/CreateKeyAccountManager';
import { useDispatch, useSelector } from 'react-redux';

import { ErrorMessage } from 'formik';
import { Button, Select, Spin } from 'antd';
import styled from 'styled-components';
import { BottomContent, DetailRow, LeftContent, TitleDiv, TitleRow } from '../../../StyledComponents/Markup';
import { createOdccMarkup, getOdccStrategiesList, updateOdccMarkup } from '../../../store/Markup/markupSlice';
import { allcountrycode, updatenotificationdata } from '../../../store/Common/CommonSlice';
import SimpleInput from '../../Admin/Common/SimpleInput';
import { createCustomerContact, getCustomerContacts, updateCustomerContact } from '../../../store/CutomerContact/contactSlice';
import SelectMultipleWithSearch from '../../Admin/MarkupManagement/SelectMultipleWithSearch';

const createContactSchema = Yup.object().shape({
    salutation: Yup.string()
        .trim()
        .min(2, "Salutation must be between 2 and 5 characters long")
        .max(5, "Salutation must be between 2 and 5 characters long")
        .required("Salutation is required"),

    name: Yup.string()
        .trim()
        .min(3, "Name must be at least 3 characters long")
        .required("Name is required"),

    email: Yup.string()
        .trim()
        .email("Invalid email address")
        .optional(),

    organizationName: Yup.string()
        .trim()
        .required("Organization name is required"),

    countryCode: Yup.string()
        .trim()
        .nullable(),

    whatappNumber: Yup.string()
        .trim()
        .matches(/^\d{10}$/, "WhatsApp number must be exactly 10 digits")
        .nullable(),
}).test("countryCode-required-if-whatsapp", "Country code is required if WhatsApp number is provided", function (values) {
    if (values.whatappNumber && !values.countryCode) {
        return this.createError({ path: "countryCode", message: "Country code is required if WhatsApp number is provided" });
    }
    return true;
}).test("whatsapp-required-if-countryCode", "WhatsApp number is required if country code is provided", function (values) {
    if (values.countryCode && !values.whatappNumber) {
        return this.createError({ path: "whatappNumber", message: "WhatsApp number is required if country code is provided" });
    }
    return true;
});

let initialValues = {
    salutation: undefined,
    name: undefined,
    email: undefined,
    organizationName: undefined,
    countryCode: undefined,
    whatappNumber: undefined,
}
function CreateContactForm({ pageType, existedContact, setPageType }) {
    const [loading, setLoading] = useState(false);
    const [updatedData, setUpdatingData] = useState(existedContact);
    const [type, setType] = useState(pageType || "create");
    console.log(pageType,"pageType")

    const getAllCountryCode = useSelector(allcountrycode);
    let allCountryCode = getAllCountryCode?.data?.map((element) => {
        return {
            _id: element._id,
            name: "Abc",
            value: "Abc",
            code: `+ ${element.country_code} : ${element.name}`
        }
    }) || [];
    const dispatch = useDispatch();

    if (type == "edit") {
        // console.log(getAllCountryCode)
        let finalCountryCode = existedContact?.countryCode && getAllCountryCode.data.find(
            (element) => element.country_code === existedContact.countryCode
        );
        finalCountryCode = finalCountryCode != undefined ? `+ ${finalCountryCode.country_code} : ${finalCountryCode.name}` : undefined;
        initialValues = {
            salutation: existedContact.salutation,
            name: existedContact.name,
            email: existedContact?.email || undefined,
            organizationName: existedContact?.organizationName || undefined,
            countryCode: finalCountryCode,
            whatappNumber: existedContact?.whatappNumber || undefined,
        }
    } else {
        initialValues = {
            salutation: undefined,
            name: undefined,
            email: undefined,
            organizationName: undefined,
            countryCode: undefined,
            whatappNumber: undefined,
        }
    }
    const handlecancel = () => {

        setPageType("table")
    }
    const handleSelectChange = (e, name, setFieldValue) => {
        setFieldValue([name], e);

    }
    const handleDateChange = (key, date, dateString, setFieldValue) => {
        setFieldValue(key, date);

    };
    return < >
        {
            loading ? <SpinContainer className='user-quote'>
                <Spin />
            </SpinContainer> : <FormikForm
                initialValues={initialValues}
                validationSchema={createContactSchema}
                onSubmit={(values, { resetForm, setFieldValue }) => {
                    const mappedData = {
                        salutation: values.salutation,
                        name: values.name,
                        email: values?.email || undefined,
                        organizationName: values.organizationName,
                        countryCode: values?.countryCode && values?.countryCode.split(":")[0].split(" ")[1] || undefined,
                        whatappNumber: values.whatappNumber
                    };
                  //  setLoading(true)
                    if (pageType != "edit") {
                        dispatch(createCustomerContact(mappedData)).then((res) => {

                            if (res.payload.success == "success") {
                                setPageType('table');
                                dispatch(updatenotificationdata(res.payload))
                                dispatch(getCustomerContacts(""));
                            } else if(res.payload.success == "error") {
                                dispatch(updatenotificationdata(res.payload))
                                
                                console.log("*****")
                               
                            }

                        }).catch((error) => {
                            dispatch(updatenotificationdata(error.payload));
                            console.log("errrrr0", error)

                        }).finally(() => setLoading(false))
                    } else {
                        const forUpdate = {
                            id: existedContact?._id,
                            data: mappedData
                        }
                        dispatch(updateCustomerContact(forUpdate)).then((res) => {
                            if (res.payload.success == "success") {
                                setPageType('table');
                                dispatch(updatenotificationdata(res.payload))
                                dispatch(getCustomerContacts(""));
                            } else if(res.payload.success == "error") {
                                dispatch(updatenotificationdata(res.payload))
                                
                                console.log("*****")
                               
                            }

                        }).catch((error) => {
                            console.log(error, 'updateerror')
                        }).finally(() => setLoading(false))
                    }
                }}
            >
                {({ values, setFieldValue, handleChange, handleBlur, resetForm }) => (
                    <FormItem >
                        <DetailContainer>
                            <BottomContent>
                                <LeftContent>
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Salutation*</TitleRow></TitleDiv>

                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>

                                            <SimpleInput
                                                id="salutation"
                                                name="salutation"
                                                type="text"
                                                value={values?.salutation}
                                                size="large"
                                                placeholder='Salutation'
                                                handleChange={handleChange}
                                            />
                                            <ErrorMessage name="salutation" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>

                                    </DetailRow>

                                    {/* Name */}
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Name*</TitleRow></TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <SimpleInput
                                                id="name"
                                                name="name"
                                                type="text"
                                                value={values?.name}
                                                size="large"
                                                placeholder='Full Name'
                                                handleChange={handleChange}
                                            />
                                            <ErrorMessage name="name" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>

                                    {/* Email */}
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Email</TitleRow></TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <SimpleInput
                                                id="email"
                                                name="email"
                                                type="email"
                                                value={values?.email}
                                                size="large"
                                                placeholder='Email Address'
                                                handleChange={handleChange}
                                            />
                                            <ErrorMessage name="email" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>

                                    {/* Organization Name */}
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Organization Name*</TitleRow></TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <SimpleInput
                                                id="organizationName"
                                                name="organizationName"
                                                type="text"
                                                value={values?.organizationName}
                                                size="large"
                                                placeholder='Organization Name'
                                                handleChange={handleChange}
                                            />
                                            <ErrorMessage name="organizationName" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>

                                    {/* Country Code */}
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Country Code</TitleRow></TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            {/* <SimpleInput
                                                id="countryCode"
                                                name="countryCode"
                                                type="text"
                                                value={values?.countryCode}
                                                size="large"
                                                placeholder='Country Code (e.g., +91)'
                                                handleChange={handleChange}
                                            /> */}

                                            <SelectMultipleWithSearch name="countryCode" setFieldValue={setFieldValue} value={values?.countryCode} options={allCountryCode} width="100%" bradius="8px" placeholder="Country Code (e.g., +91)" />
                                            <ErrorMessage name="countryCode" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>

                                    {/* WhatsApp Number */}
                                    <DetailRow>
                                        <TitleDiv><TitleRow>WhatsApp Number</TitleRow></TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <SimpleInput
                                                id="whatappNumber"
                                                name="whatappNumber"
                                                type="text"
                                                value={values?.whatappNumber}
                                                size="large"
                                                placeholder='WhatsApp Number'
                                                handleChange={handleChange}
                                            />
                                            <ErrorMessage name="whatappNumber" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>


                                </LeftContent>
                            </BottomContent>
                            {/* <Button
                                className="bg-[#679fee] w-fit ml-6 font-normal md:font-medium"
                                type="submit"
                                htmlType="submit"
                                loading={loading}
                            >
                                {type == 'edit' ? "Update" : "Create"}
                            </Button> */}
                            <div className="flex justify-end space-x-4">
                                <button
                                    type="button"
                                    className="bg-black text-white hover:bg-yellow-500 font-bold py-2 px-4 rounded-md hover:text-white"
                                    onClick={handlecancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="bg-yellow-500 text-white hover:bg-black font-bold py-2 px-4 rounded-md hover:text-white"
                                >
                                    Submit
                                </button>
                            </div>
                        </DetailContainer>
                    </FormItem>
                )}
            </FormikForm>
        }
    </>
}

export default CreateContactForm;
const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: 8px !important;
        padding: ${({ pdg }) => pdg ? pdg : "unset"};
    }
    & .ant-select-selection-placeholder {
        color: #d9d9d9 !important;
        font-size: 16px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #d9d9d9 !important
    }
    /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`